{
  "pageTitle": "Addresses",
  "addAddress": "Add Address",
  "addShort": "Add",
  "editAddress": "Edit Address",
  "noAddressesYet": "No addresses yet",
  "noAddressesHint": "Add your first address to assign providers and start scraping.",
  "noProvidersAvailable": "No providers available",
  "providersCount": "{{count}} provider(s)",
  "manageProviders": "Manage Providers",
  "hideProviders": "Hide Providers",
  "assignProvider": "Assign Provider",
  "assignProviderFirst": "Add first provider",
  "editProvider": "Edit Provider",
  "removeProvider": "Remove",
  "selectProvider": "Select provider",
  "newPasswordHint": "New password (leave blank to keep)",
  "passwordSet": "Password is set",
  "save": "Save",
  "cancel": "Cancel",
  "assign": "Assign",
  "deleteConfirm": "Delete this address?",
  "saveError": "Failed to save",
  "deleteError": "Failed to delete",
  "assignError": "Failed to assign",
  "removeError": "Failed to remove",
  "updateError": "Failed to update",
  "deleteConfirmPrompt": "Are you sure you want to delete this address?",
  "placeholder": {
    "addressName": "e.g. Home, Office",
    "username": "Username",
    "password": "Password",
    "accountKeyword": "e.g. ASA Banka d.d. Sarajevo",
    "taxDeductionAmount": "Amount",
    "invoiceEmailTo": "e.g. name@example.com"
  },
  "label": {
    "skipPayment": "Skip payment",
    "taxDeduction": "Enable tax deduction",
    "meterReadingEnabled": "Use for meter readings",
    "invoiceEmailTo": "Send new invoices by email to"
  }
}
